import * as React from 'react';
import {
  Grid,
  Box,
  TextField,
} from '@material-ui/core';
import type ICompanyContactDetails from './CompanyInterfaces';

interface CompanyOverviewProps {
  formValues: ICompanyContactDetails;
  setFormValues: (formValues: ICompanyContactDetails) => void;
}

const CompanyOverview: React.FC<CompanyOverviewProps> = ({
  formValues: companyFormValues, setFormValues: setCompanyFormValues,
}) => (
  <>
    <Grid container spacing={0}>
      <Grid lg={5} md={4} xs={12}>
        <Grid item>
          <Box p={2}>
            <TextField
              value={companyFormValues.name || ''}
              id="company-name-value-input"
              required
              label="Company Name"
              variant="outlined"
              type="string"
              fullWidth
              onChange={(event) => {
                const inputVal = event.target.value;
                console.log(inputVal);
                setCompanyFormValues({ ...companyFormValues, name: inputVal });
              }}
            />
          </Box>
        </Grid>
      </Grid>
    </Grid>
  </>
);

export default CompanyOverview;
